import { NgModule } from '@angular/core';
import { PercentageCircleComponent } from './percentage-circle.component';
import { SharedProviderModule } from '../../shared/shared.module';

@NgModule({
  imports: [
    SharedProviderModule
  ],
  declarations: [PercentageCircleComponent],
  exports: [PercentageCircleComponent]
})
export class PercentageCircleModule { }
